/**
 * @description question response model
 * @date 2019-03-30
 * @author jywang
 */
import React, { PureComponent } from 'react';
import { DatePicker, Pagination, Input } from 'antd';
import { UnitLi } from './component/unit-li';
import { inject } from 'mobx-react';
import { observer } from 'mobx-react/custom';
import moment from 'moment';
import './index.scss';
const { RangePicker } = DatePicker;
@inject('store')
@observer
class QuestionResponse extends React.Component<any, any> {
    public searchParam: any = {};
    constructor(props) {
        super(props);
    }
    public componentWillMount() {
        this.props.store.hasLoginManage();
        this.getList();
    }
    public render() {
        const { store } = this.props;
        const { answerList } = store;
        return (
            <div className="question-response-box">
                <nav className="tabCon justify-box">
                    <div className="tabBox">
                        时间选择
                        <div className="date-box">
                            <RangePicker onChange={this.dataOnChange} />
                        </div>
                    </div>
                    <div className="tabBox">
                        {/* 时间选择 */}
                        <div className="date-box">
                            <Input placeholder="搜索你感兴趣的问题" onChange={this.titleOnChange} />
                        </div>
                    </div>
                </nav>
                <div className="question-response-list-box">
                    <ul hidden={!answerList.results || answerList.results.length <= 0}>
                        {
                            answerList.results && answerList.results.length > 0 && answerList.results.map((item, idx) => {
                                return (<li key={idx}>
                                    <UnitLi checkAnswer={answerList.checkAnswer} status={item.status} imageUrls={item.images} surfacePlot={item.surfacePlot} title={item.title} answerSum={item.answerSum} collectSum={item.collectSum} releaseTime={moment(item.releaseTime).format('YYYY-MM-DD HH:mm:ss')} id={item.id} />
                                </li>);
                            })
                        }
                    </ul>
                    <p hidden={answerList.dataStatus !== 'done' || answerList.dataStatus === 'done' && answerList.results && answerList.results.length > 0} className="no-data">暂无数据</p>
                    <p hidden={answerList.dataStatus !== 'pending'} className="no-data">加载数据中...</p>
                </div>
                <div className="page-box">
                    <Pagination size="small" onShowSizeChange={this.onShowSizeChange} onChange={this.pageChange} defaultCurrent={answerList.pageNo} defaultPageSize={answerList.pageSize} total={answerList.totalCount} showSizeChanger={true} showQuickJumper={true} />
                </div>
            </div>
        );
    }
    public dataOnChange = (date, dateString) => {
        console.log(date, dateString);
        if (date[0] && date[1]) {
            const startDate = moment(date[0]).format('YYYY-MM-DD') + ' 00:00:00';
            const endDate = moment(date[1]).format('YYYY-MM-DD') + ' 23:59:59';
            const dateAtMix = moment(startDate).format();
            const dateAtMax = moment(endDate).format();
            const info: any = {};
            info.dateAtMix = dateAtMix;
            info.dateAtMax = dateAtMax;
            info.pageNo = 1;
            info.pageSize = 10;
            this.getList(info);
        } else {
            delete this.searchParam.dateAtMix;
            delete this.searchParam.dateAtMax;
            this.getList(this.searchParam);
        }
    }
    public titleOnChange = (e) => {
        console.log(e.target.value);
        const title = e.target.value;
        const info: any = {};
        info.name = title;
        info.pageNo = 1;
        info.pageSize = 10;
        this.getList(info);
    }
    public pageChange = (current, size) => {
        console.log(current, size);
        const info: any = {};
        info.pageNo = current;
        info.pageSize = size;
        this.getList(info);
    }
    public onShowSizeChange = (current, size) => {
        console.log(current, size);
        const info: any = {};
        info.pageNo = current;
        info.pageSize = size;
        this.getList(info);
    }
    public getList = (param: any = {}) => {
        const info: any = {};
        info.pageNo = 1;
        info.pageSize = 10;
        this.searchParam = Object.assign(info, this.searchParam, param);
        this.props.store.answerList.get(this.searchParam);
    }
}
export default QuestionResponse;
